import React from "react";
import mulletHairCutImg from "./../../../Images/HairSalonInnerPage/Modern Mullet Hair Cut.png";

const MulletHairCutImg = () => {
  return (
    <div className="faceImgContainer">
      <img src={mulletHairCutImg} alt="mulletHairCutImg" />
    </div>
  );
};

export default MulletHairCutImg;
